module.exports = __webpack_public_path__ + "static/media/phone_v2.e56b4169.png";